import React from "react";
import styles from "./UserAvatar.module.scss";
import classnames from "classnames";
import { UserAvatarSizes, UserAvatarSize } from "./UserAvatarSizes";

interface UserAvatarProps {
  userInitials?: string;
  userAvatarImageSrc?: string;
  backgroundColor?: string;
  size?: UserAvatarSize;
}

export default function UserAvatar({
  userInitials,
  userAvatarImageSrc,
  backgroundColor = "#2B333B",
  size = UserAvatarSizes.Medium,
}: UserAvatarProps) {
  let userAvatarContentJsx: React.ReactNode = null;

  if (!!userAvatarImageSrc) {
    userAvatarContentJsx = (
      <img
        className={styles.avatarImage}
        src={userAvatarImageSrc}
        alt="User avatar"
      />
    );
  } else if (!!userInitials) {
    userAvatarContentJsx = (
      <div className={styles.initials}>{userInitials}</div>
    );
  } else {
    userAvatarContentJsx = (
      <i className={classnames(styles.defaultUserIcon, "fa-solid fa-user")} />
    );
  }

  const avatarStyles = !!backgroundColor
    ? { backgroundColor, borderColor: backgroundColor }
    : undefined;

  return (
    <div className={classnames(styles.root, styles[size])} style={avatarStyles}>
      {userAvatarContentJsx}
    </div>
  );
}
